<template>
  <div id="app3">
    <Card :class="{ blackBackGroup: isActive, blackBackGroup2: !isActive }" style="font-family: Arial, Helvetica, Sans-Serif;">
      <p slot="title">每日商店</p>
      <div slot="extra"></div>

      <div class="shop-panel">
        <div class="shop-toolbar">
          <span class="shop-summary-title">今日上架 {{ shopList.length }} 件</span>
          <Button size="small" type="info" ghost @click="waresList">刷新</Button>
        </div>

        <div v-if="!shopList.length" class="shop-empty">暂无可购买商品</div>

        <div class="shop-grid">
          <Poptip
            v-for="item in shopList"
            :key="item.marketName"
            trigger="hover"
            :title="item.marketName.toString()"
          >
            <div class="shop-item-card" :class="{ dark: isActive }">
              <div class="shop-item-head">
                <p class="shop-item-name" :style="{ color: distinguishColor(item.color) }">{{ item.marketName }}</p>
                <Tag color="blue">剩余 {{ item.marketNum || 0 }}</Tag>
              </div>

              <div class="shop-item-price" v-if="item.marketPrice">
                价格：<span class="shop-item-price-num">{{ item.marketPrice }}</span> {{ priceTypeText(item.priceType) }}
              </div>

              <div class="shop-item-desc" v-if="item.marketDec">{{ item.marketDec }}</div>

              <div class="shop-item-actions">
                <Button @click.prevent="purchaseItem(item)" size="small" type="info" ghost>购买</Button>
                <Button @click.prevent="purchaseItem1(item)" size="small" type="info">批量</Button>
              </div>
            </div>

            <div slot="content">
              <p>{{ item.marketName }}</p>
              <p v-if="item.marketDec">{{ item.marketDec }}</p>
              <p>剩余次数：{{ item.marketNum || 0 }}</p>
              <p>最低等级：{{ item.marketLevel || '无限制' }}</p>
              <p v-if="item.marketPrice">价格：{{ item.marketPrice }} {{ priceTypeText(item.priceType) }}</p>
              <p v-if="item.typeDec">类型：{{ item.typeDec }}</p>
              <p v-if="item.life">生命：{{ item.life }}</p>
              <p v-if="item.mana">真气：{{ item.mana }}</p>
              <p v-if="item.attack">攻击：{{ item.attack }}</p>
              <p v-if="item.magAttack">灵攻：{{ item.magAttack }}</p>
              <p v-if="item.defense">防御：{{ item.defense }}</p>
              <p v-if="item.magicDefense">法防：{{ item.magicDefense }}</p>
            </div>
          </Poptip>
        </div>
      </div>

      <Modal
        width="620"
        title="批量购买"
        v-model="batchEject"
        @on-ok="bulkPurchase()"
        :styles="{ top: '100px' }"
      >
        <div>
          <Input v-model="batchNum" type="Number" placeholder="请输入数量" />
        </div>
      </Modal>
    </Card>
  </div>
</template>

<script>
import Im from "./Im";

export default {
  name: "playersList",
  data() {
    return {
      shopList: [],
      batchNum: 1,
      isActive: false,
      batchEject: false,
      marketId: "",
    };
  },
  created() {
    this.waresList();
    const theme = window.localStorage.getItem("isTheme");
    this.isActive = theme === "black";
  },
  methods: {
    fanhui() {
      this.$router.back(-1);
    },
    distinguishColor(color) {
      if (color == 1) return "#000";
      if (color == 2) return "#c5c52f";
      if (color == 3) return "#049c04";
      if (color == 4) return "#005aff";
      if (color == 5) return "#ff00e0";
      if (color == 6) return "#ff0000";
      if (color == 7) return "#ff8c00";
      return "#ff00c3e0";
    },
    priceTypeText(type) {
      return type == 0 ? "金币" : "灵石";
    },
    buildShopDetail(item) {
      const detailMap = [
        { label: "商品价格", value: item.marketPrice ? `${item.marketPrice} ${this.priceTypeText(item.priceType)}` : "" },
        { label: "可购次数", value: item.marketNum },
        { label: "最低等级", value: item.marketLevel },
        { label: "装备类型", value: item.typeDec },
        { label: "装备等级", value: item.level },
        { label: "物品数量", value: item.itemNum },
        { label: "生命", value: item.life },
        { label: "真气", value: item.mana },
        { label: "攻击", value: item.attack },
        { label: "灵攻", value: item.magAttack },
        { label: "防御", value: item.defense },
        { label: "法防", value: item.magicDefense },
        { label: "暴击率", value: item.critical ? `${(item.critical * 100).toFixed(2)}%` : "" },
        { label: "速度", value: item.speed },
        { label: "根骨", value: item.physique },
        { label: "力道", value: item.dexterous },
        { label: "灵力", value: item.spirit },
        { label: "物品描述", value: item.marketDec },
      ];
      return detailMap.filter(detail => detail.value !== "" && detail.value !== null && detail.value !== undefined);
    },
    waresList() {
      this.$http
        .post("/gameMarket/waresList?charaId=" + this.getCookie("charaId"))
        .then((res) => {
          this.shopList = res.data.data || [];
        });
    },
    purchaseItem(item) {
      this.$http
        .post(
          "/gameMarket/buyWares?charaId=" +
            this.getCookie("charaId") +
            "&waresId=" +
            item.marketId +
            "&waresNum=" +
            1
        )
        .then((res) => {
          this.$Notice.warning({ title: res.data.msg });
          Im.methods.send2(
            Im.data().chatUser,
            res.data.msg,
            Im.data().chatPindao,
            "系统消息",
            Im.data().socketObj
          );
          this.waresList();
          this.$bus.$emit("shopMsg", "商店购买完成");
        })
        .catch((err) => {
          this.$Notice.warning({ title: err.data.msg });
        });
    },
    purchaseItem1(item) {
      this.batchEject = true;
      this.marketId = item.marketId;
      this.batchNum = item.marketNum || 1;
    },
    bulkPurchase() {
      this.$http
        .post(
          "/gameMarket/buyWares?charaId=" +
            this.getCookie("charaId") +
            "&waresId=" +
            this.marketId +
            "&waresNum=" +
            this.batchNum
        )
        .then((res) => {
          this.$Notice.warning({ title: res.data.msg });
          this.waresList();
          this.$bus.$emit("shopMsg1", "商店批量购买完成");
        })
        .catch((err) => {
          this.$Notice.warning({ title: err.data.msg });
        });
    },
  },
};
</script>

<style scoped>
#app3 {
  width: 99%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  position: relative;
}

* {
  font-family: "Microsoft YaHei", sans-serif;
}

.shop-panel {
  width: 100%;
}

.shop-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.shop-summary-title {
  color: #808695;
  font-size: 13px;
}

.shop-empty {
  padding: 24px 0;
  text-align: center;
  color: #808695;
}

.shop-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 12px;
}

.shop-item-card {
  border: 1px solid #e8eaec;
  border-radius: 10px;
  padding: 12px;
  background: #fff;
  min-height: 130px;
  transition: all 0.2s ease;
}

.shop-item-card:hover {
  border-color: #5cadff;
  box-shadow: 0 6px 16px rgba(45, 140, 240, 0.12);
  transform: translateY(-2px);
}

.shop-item-card.dark {
  border-color: #373e57;
  background: #1f2335;
}

.shop-item-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.shop-item-name {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.3;
}

.shop-item-price {
  margin-top: 10px;
  color: #515a6e;
  font-size: 13px;
}

.shop-item-price-num {
  color: #ed4014;
  font-weight: 700;
}

.shop-item-desc {
  margin-top: 8px;
  font-size: 12px;
  color: #808695;
  line-height: 1.45;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.shop-item-actions {
  margin-top: 12px;
  display: flex;
  gap: 8px;
}

.blackBackGroup {
  background-color: #151728;
  border: none;
  color: #9c9cab;
}

.blackBackGroup .ivu-card-head p,
.blackBackGroup .ivu-card-head-inner {
  color: #4975d4;
}

.blackBackGroup .shop-summary-title,
.blackBackGroup .shop-empty,
.blackBackGroup .shop-item-price,
.blackBackGroup .shop-item-desc {
  color: #b9bed1;
}

.blackBackGroup /deep/ .ivu-poptip-popper .ivu-poptip-content .ivu-poptip-inner {
  background-color: rgba(70, 76, 91, 0.9);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}

.blackBackGroup /deep/ .ivu-poptip-popper .ivu-poptip-content .ivu-poptip-arrow:after {
  border-top-color: rgba(70, 76, 91, 0.9);
}

.blackBackGroup /deep/ .ivu-poptip-popper .ivu-poptip-content .ivu-poptip-title,
.blackBackGroup /deep/ .ivu-poptip-popper .ivu-poptip-content .ivu-poptip-title-inner,
.blackBackGroup /deep/ .ivu-poptip-popper .ivu-poptip-content .ivu-poptip-body {
  background: #373e57;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/shop.vue